module.exports = __webpack_public_path__ + "img/historia_3-4_2304.06b394f5.webp";